<template>
  <div class="box" :class="classes">
	  <div class="box-header" v-if="label" @click.stop="headerToggleOpen()" :class="{'togglable':(headerToggle != undefined)}">
		  {{label}}
      <div class="toggler" v-if="open==true || open==false" :class="{open:(open==true)}" @click="togglerToggleOpen()">
        <svgicon icon="ionicons/chevron-right"></svgicon>
      </div>
      <div class="meta-r" v-if="$slots['meta-r']">
        <slot name="meta-r"></slot>
      </div>
	  </div>
	  <div class="box-content" v-if="open == undefined || open == true">
		  <slot></slot>
	  </div>
  </div>
</template>

<script>
import Btn from './../components/Btn'
import './../components/generated_svg_icons/ionicons/chevron-right'
export default {
  name: 'box',
  components: { Btn },
  props: [ 'label', 'open', 'header-toggle', ],
  computed:{
    classes(){
      var output = ''
      //if( this._props.w != undefined ) output += 'w'+this._props.w
      return output
    },
  },
  methods: {
    toggleOpen(){
      if( this._events['toggledOpen'] ) {
        this.$emit('toggledOpen', !this._props.open )
      } else {
        this._props.open = !this._props.open
      }
    },
    headerToggleOpen(){
      if( this._props.headerToggle != undefined ) this.toggleOpen()
    },
    togglerToggleOpen(){
      if( this._props.headerToggle == undefined ) this.toggleOpen()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Box.vue